import './ValidationResponse.scss';

import React from 'react';
import { Header } from 'components/header/header';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import SuccessPartySVG from '../assets/images/success-party.svg';
import CoffeeCupSVG from '../assets/images/coffee-cup.svg';
import { connect } from 'react-redux';
import { RESULT_LOAN_APPROVED, RESULT_LOAN_COUNTEROFFER } from '../commons/constants/steps';
import LoanSummaryTable from '../commons/components/LoanSummaryTable/LoanSummaryTable';
import { ValidationHeader } from './components/ValidationHeader';
import { loanCancel, loanHiring } from 'actions/aresActions';
import { showPreLoader } from 'actions/preLoaderActions';
import { bindActionCreators } from 'redux';
import { CancellationModal } from './components/CancellationModal';
import { recordEvent } from 'utilities/uTagging';
import { ARES_PRODUCT_ID, ARES_PRODUCT_CATEGORY, ARES_PRODUCT_NAME } from 'utilities/uTagging';
import { formatText, HtmlText } from 'core/i18n';
import { recordAndSavePage } from 'actions/errorViewNavigation';

class ValidationResponse extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isCanceling: false };
    }

    componentDidMount() {
        const { recordAndSavePage } = this.props;
        const { status } = this.props.userProfile;

        const urlByStatus = {
            [RESULT_LOAN_APPROVED]: '/onboarding/prestamo-aprobado/',
            [RESULT_LOAN_COUNTEROFFER]: '/onboarding/prestamo-contraoferta/',
        };

        recordAndSavePage(
            urlByStatus[status],
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            'ares',
            {
                tipoPagina: 'generica',
                tipoProceso: 'onboarding',
                pasoProceso: 'prestamo-aprobado',
                tipoOnboarding: 'ares',
                productoOnboardingDetalle: 'prestamo ares',
                tealium_event: 'purchase',
                product_id: ARES_PRODUCT_ID,
                product_name: ARES_PRODUCT_NAME,
                product_category: ARES_PRODUCT_CATEGORY,
            }
        );
    }

    isLoanApproved = () => {
        const { status } = this.props.userProfile;

        return status === RESULT_LOAN_APPROVED;
    };

    getHeaderInfo = () => {
        const successConfig = {
            icon: SuccessPartySVG,
            stepResolution: 'success',
            headingText: formatText('loanApproved-title_ares'),
            subHeadingText: formatText('loanApproved-text1_ares'),
        };

        const counterOfferConfig = {
            icon: CoffeeCupSVG,
            stepResolution: 'alternative',
            headingText: formatText('loanCounteroffer-title_ares'),
            subHeadingText: formatText('loanCounteroffer-text1_ares'),
        };

        return this.isLoanApproved() ? successConfig : counterOfferConfig;
    };

    triggerCancellation = () => {
        const { showPreLoader, makeCancellation } = this.props;
        this.closeModal();
        showPreLoader();
        makeCancellation();
    };

    triggerHiring = () => {
        const { showPreLoader, makeHiring } = this.props;
        showPreLoader();
        makeHiring();
    };

    openModal = () => {
        this.setState({ isCanceling: true });
    };

    closeModal = () => {
        this.setState({ isCanceling: false });
    };

    handleRecordEvent = payload => {
        recordEvent(
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            payload
        );
    };

    onButtonContinueAction = () => {
        this.handleRecordEvent({
            categoriaEvento: `interaccion en onboarding prestamo ${
                this.isLoanApproved() ? 'aprobado' : 'contraoferta'
            }`,
            accionEvento: 'contratar',
        });
        this.triggerHiring();
    };

    onButtonCancelAction = () => {
        this.handleRecordEvent({
            categoriaEvento: `interaccion en onboarding prestamo ${
                this.isLoanApproved() ? 'aprobado' : 'contraoferta'
            }`,
            accionEvento: 'cancelar solicitud',
        });
        this.openModal();
    };

    render() {
        const {
            userProfile: { amount, monthlyFee, openingFee, tae, term, tin, totalAmount, totalCost },
        } = this.props;

        const { isCanceling } = this.state;

        const { icon, stepResolution, headingText, subHeadingText } = this.getHeaderInfo();

        return (
            <React.Fragment>
                <div className="prospects-content">
                    <Header />
                    <div className="validation-response__container">
                        <ValidationHeader
                            stepResolution={stepResolution}
                            icon={icon}
                            headingText={headingText}
                            subHeadingText={subHeadingText}
                        />
                        <div className="validation-response__summary-table">
                            <div className="validation-response__loan-summary-table-container">
                                <LoanSummaryTable
                                    amount={amount}
                                    frequency={term}
                                    tin={tin}
                                    tae={tae}
                                    openingFee={openingFee}
                                    totalAmount={totalAmount}
                                    monthlyFee={monthlyFee}
                                    totalCost={totalCost}
                                />
                            </div>
                            <div className="validation-response__cancel-text-container">
                                <a onClick={this.openModal}>{formatText('loanCounteroffer-cancelAction_ares')}</a>
                                <CancellationModal
                                    isOpen={isCanceling}
                                    close={event => {
                                        event.preventDefault();
                                        this.closeModal();
                                    }}
                                    onConfirm={this.triggerCancellation}
                                />
                            </div>
                            <div className="validation-response__legal">
                                <p>{HtmlText(formatText('standbyLoan-legaltext1_ares'))}</p>
                            </div>
                            <div className="form__footer">
                                <RoadmapNavigation
                                    buttonFinalizeHidden={false}
                                    buttonPrevHidden={true}
                                    buttonCancelAction={this.onButtonCancelAction}
                                    buttonContinueAction={this.onButtonContinueAction}
                                    buttonFinalizeText={formatText('button-hiring')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default connect(
    state => ({
        userProfile: state.userProfile,
    }),
    dispatch => ({
        makeCancellation: loanCancel,
        makeHiring: () => loanHiring(dispatch),
        showPreLoader: bindActionCreators(showPreLoader, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(ValidationResponse);
